import {useI18n} from '@yandex-delivery/core/i18n'
import {Button, ButtonProps, Grid, PlusInvertIcon} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import * as classes from './PaymentCardAddButton.classes'

export const PaymentCardAddButton = memo(function PaymentCardAddButton(props: ButtonProps): React.ReactElement {
  const t = useI18n()

  return (
    <Button className={classes.button} variant="outline" fullWidth {...props}>
      <Grid size="s" container>
        <Grid className={classes.icon} component={PlusInvertIcon} xs={12} item />
        <Grid xs={12} item>
          {t('card_list_form.add_new_card')}
        </Grid>
      </Grid>
    </Button>
  )
})
